module.exports = __webpack_public_path__ + "images/home/product/wechat-miniprogram-todo-detail-82ce4a24af7345dd16130705e778e0b1.png";